import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

const FS_CONNECTION_CONFIG = new InjectionToken('fs-connection-config');

class FsConnectionService {
    constructor(_config) {
        this._config = _config;
        this._connection$ = new Subject();
        this._destroy$ = new Subject();
    }
    get isDown() {
        return !navigator.onLine;
    }
    get isUp() {
        return navigator.onLine;
    }
    get down$() {
        return this._connection$.asObservable()
            .pipe(filter((value) => !value), takeUntil(this._destroy$));
    }
    get up$() {
        return this._connection$.asObservable()
            .pipe(filter((value) => value), takeUntil(this._destroy$));
    }
    set showBanner(value) {
        let offline = document.getElementById('fs-offline');
        if (value) {
            if (offline) {
                offline.textContent = 'Internet connection restored';
                offline.classList.remove('fs-offline-down');
                offline.classList.add('fs-offline-up');
                setTimeout(() => {
                    offline.remove();
                }, 4000);
            }
        }
        else {
            if (!offline) {
                offline = document.createElement('div');
                offline.setAttribute('id', 'fs-offline');
                offline.classList.add('fs-offline-down');
                offline.textContent = 'No iternet connection';
                document.getElementsByTagName('body')[0].append(offline);
            }
        }
    }
    ngOnDestroy() {
        window.removeEventListener('online', this._upHandler);
        window.removeEventListener('offline', this._downHandler);
        this._destroy$.next();
        this._destroy$.complete();
    }
    init() {
        this._connection$
            .pipe(filter(() => this._config.showBanner), takeUntil(this._destroy$))
            .subscribe((value) => {
            this.showBanner = value;
        });
        this._downHandler = () => {
            this._connection$.next(false);
        };
        this._upHandler = () => {
            this._connection$.next(true);
        };
        window.addEventListener('online', this._upHandler);
        window.addEventListener('offline', this._downHandler);
        timer(0, 10000)
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
            this._connection$.next(this.isUp);
        });
    }
}
FsConnectionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionService, deps: [{ token: FS_CONNECTION_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
FsConnectionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FS_CONNECTION_CONFIG]
                }] }]; } });

class FsConnectionModule {
    constructor(_service) {
        this._service = _service;
        this._service.init();
    }
    static forRoot(config) {
        return {
            ngModule: FsConnectionModule,
            providers: [
                FsConnectionService,
                { provide: FS_CONNECTION_CONFIG, useValue: config || {} },
            ]
        };
    }
}
FsConnectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionModule, deps: [{ token: FsConnectionService }], target: i0.ɵɵFactoryTarget.NgModule });
FsConnectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionModule });
FsConnectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionModule, providers: [
        FsConnectionService,
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsConnectionModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        FsConnectionService,
                    ]
                }]
        }], ctorParameters: function () { return [{ type: FsConnectionService }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { FsConnectionModule, FsConnectionService };
